import { render, staticRenderFns } from "./runForIt_v1.vue?vue&type=template&id=979e4df8&scoped=true&"
import script from "./runForIt_v1.vue?vue&type=script&lang=js&"
export * from "./runForIt_v1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979e4df8",
  null
  
)

export default component.exports